import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid2 as Grid, Typography } from '@mui/material';
import { ILink } from '../../shared.interfaces';
import { TypographyStyledBlack, LinkStyled, Item } from './style';
import buttonNext from '../../../assets/icons/buttonNext.svg';
import DisabledButtonNext from '../../../assets/icons/disabledButtonNext.svg';

export const TileSleekComponent = (props: ILink) => {
  const { imgSrc, altVal } = props;
  const navigate = useNavigate();

  return (
    <div style={{ width: '100%' }}>
      <Grid
        size={12}
        sx={{
          borderRadius: '0.9375rem',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#fff',
          gap: '0.625rem'
        }}
      >
        <Item>
          <TypographyStyledBlack sx={{ lineHeight: '33px' }}>
            {props.tileText}
          </TypographyStyledBlack>
          <LinkStyled
            onClick={() => {
              !props.disabled && navigate(props.toLink);
            }}
            data-testid={props.tileText}
            tabIndex={0}
          >
            <img
              src={
                props.disabled
                  ? DisabledButtonNext
                  : imgSrc
                    ? imgSrc
                    : buttonNext
              }
              alt={altVal ? altVal : 'Next Button Link'}
              style={{
                height: '2.5rem',
                width: '2.5rem',
                cursor: props.disabled ? 'default' : 'pointer'
              }}
            />
          </LinkStyled>
        </Item>
      </Grid>
      {props?.disabled && props?.subInfo1 && props?.subInfo2 && (
        <Typography
          sx={{
            fontFamily: 'Calibri',
            fontWeight: 400,
            fontStyle: 'italic',
            fontSize: '1rem',
            textAlign: 'center',
            width: '100%'
          }}
        >
          {`${props.subInfo1} `}
          <span style={{ fontWeight: 700 }}>{props.subInfo2}</span>
        </Typography>
      )}
    </div>
  );
};
